export default "__VITE_ASSET__Bw8BD2Lf__"